import React from 'react';
import { NavLink } from 'react-router-dom';

const AddPayslipCrumb = () => <NavLink to="/human-resources/payslips/add">Add Payslip</NavLink>;

export default AddPayslipCrumb;
